import { serviceName } from '../resources/serviceConstants';
import { SKILL_VERTICAL_DEPARTMENT_MAP } from '../resources/endPoint';

export const getSkillVerticalDepartmentMap = (verticalId, departmentId) => {
  // API call to fetch skill mapped with vertical ID

  return {
    url: SKILL_VERTICAL_DEPARTMENT_MAP + '?verticalId=' + verticalId + '&departmentId=' + departmentId,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
  };
};
